import PropTypes from 'prop-types'
import React from 'react'
import * as R from 'ramda'
import { withRouter } from 'react-router'
import urlRegex from 'url-regex'

// from
// https://stackoverflow.com/questions/51569981/how-to-use-react-links-when-rendering-content-with-dangerouslysetinnerhtml

// This source code may reproduce and may modify the following components:
//
// Name: Link.js
// Link to file: https://github.com/ReactTraining/react-router/blob/f770efd34a741d2544a2e316c1c7198345abd97e/packages/react-router-dom/modules/Link.js#L18-L23
// Copyright: Copyright (c) React Training 2016-2018
// Licence: MIT (https://github.com/ReactTraining/react-router/blob/master/LICENSE)

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
}

const contentClickHandler = router => event => {
  if (
    event.defaultPrevented && // onClick prevented default
    event.button !== 0 && // ignore everything but left clicks
    isModifiedEvent(event) // ignore clicks with modifier keys
  ) {
    return
  }

  const link = event.target.closest('a')

  if (!link) {
    return
  }

  // let browser handle "target=_blank" etc.
  if (link.target && link.target !== '_self') {
    return
  }

  event.preventDefault()

  router.push(link.href)
}

function TextEnhancedWithLinks({ text, router, mentioned_active_usernames }) {
  const text_ = text
    // parse urls
    .replace(urlRegex({ strict: false }), function(url) {
      return `<a target="_blank" href="${url}">${url}</a>`
    })
    .replace(/href="([\w.]+)"/g, function(_full_match, url) {
      // console.log('_full_match', _full_match, url)
      return `href="//${url}"`
    })
    // parse usernames
    .replace(/[@]+[A-Za-z0-9_-]+/g, function(username) {
      const username_ = username.replace('@', '').toLowerCase()

      const active = R.includes(username_, mentioned_active_usernames)
      const maybeDisabledTag = active ? '' : 'disabled'
      return `<a href="/users/${username_}" ${maybeDisabledTag} class="text-enhanced-with-links--link">${username}</a>`
    })
    // parse hashtags
    .replace(/[#]+[A-Za-z0-9_-]+/g, function(tag) {
      const tag_ = tag.replace('#', '')
      return `<a href="/search/hashtags?q=${tag_}">${tag}</a>`
    })

  return (
    <span
      onClick={contentClickHandler(router)}
      dangerouslySetInnerHTML={{ __html: text_ }}
    />
  )
}

TextEnhancedWithLinks.propTypes = {
  router:                     PropTypes.object.isRequired,
  text:                       PropTypes.string.isRequired,
  mentioned_active_usernames: PropTypes.arrayOf(PropTypes.string.isRequired)
    .isRequired,
}

export default withRouter(TextEnhancedWithLinks)
